const homePagePayload = {
  banners: {
    enable: true,
    count: 10,
  },
  products: {
    enable: true,
    count: 8,
  },
  topSellerProducts: {
    enable: true,
    count: 8,
  },
  testimonials: {
    enable: true,
    count: 5,
  },
  blogs: {
    enable: true,
    count: 3,
  },
  coupons: {
    enable: true,
  },
  categories: {
    enable: true,
    count: 10,
  },
  brands: {
    enable: true,
    count: 40,
  },
  
};

export default homePagePayload;
